import React from 'react';
import Header from '../components/Header/Header';
import ReportsHero from '../components/ReportsHero/ReportsHero';
import Footer from '../components/Footer/Footer';
import Markets from '../components/Markets/Markets';
import ReportRegions from '../components/ReportRegions/ReportRegions';
import ComprehensiveReports from '../components/ComprehensiveReports/ComprehensiveReports';
import Advantage from '../components/Advantage/Advantage';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import DeepDive from '../components/DeepDive/DeepDive'; 

const ReportsPage = () => {
  return (
    <>
      <Header />
      <main>
        <ReportsHero />
        <Markets />
        <ReportRegions />
        <ComprehensiveReports />
        <DeepDive />
        {/* You can add more report-specific sections here later */}
        <Advantage /> 
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default ReportsPage;